export default "__VITE_ASSET__f1ce867e__"